import React from "react";
import ReactDOM from "react-dom/client";
import { Capacitor } from "@capacitor/core";

//state management
import { AppProvider } from "./components/States/AppContext";

//applications
import AppPwProtected from "./pages/Login/AppPwProtected";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(

  <AppProvider>
    {Capacitor.isNativePlatform() ? <App /> : <AppPwProtected />}
    {/* <AppPwProtected /> */}
    {/* <App /> */}
  </AppProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
